import { render, staticRenderFns } from "./wexinApi.vue?vue&type=template&id=2ccd1ade&scoped=true"
import script from "./wexinApi.vue?vue&type=script&lang=js"
export * from "./wexinApi.vue?vue&type=script&lang=js"
import style0 from "./wexinApi.vue?vue&type=style&index=0&id=2ccd1ade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd1ade",
  null
  
)

export default component.exports